module.exports = __webpack_public_path__ + "img/90.cd854920.jpg";